import React from 'react';
import QuestionPanel from "../../structure/QuestionPanel";
import TextInput from "../../input/TextInput";
import DateInput from "../../input/DateInput";
import SelectDropdown from "../../input/SelectDropdown";
import { findRelationshipsFor } from "../../enums/BenefitType";
import { Party } from "../../enums/Party";
import { getKeyByValue } from "../../enums/KeyFinder";
import { Relationship } from "../../enums/Relationship";
import { useFormikContext } from "formik";
import DependentChoice from "../employee/DependentChoice";
import Callout from '../../structure/Callout';
import { PatientType } from "../../enums/PatientType";
import { EmployeeFormValues } from "../../common/EmployeeFormValues";
import RadioGroup from "../../structure/RadioGroup";
import { DependentRelationship } from "../../enums/DependentRelationship";

const AboutRelationship = () => {
    const { initialValues, values, setFieldValue } = useFormikContext<EmployeeFormValues>();
    const party = values.party;
    const relationship = values.relationship;
    const patientName = values.life ? PatientType.DECEASED : PatientType.PATIENT;
    const lowercasePatientName = patientName.toLowerCase();

    const firstNameField = `${lowercasePatientName}FirstName`;
    const lastNameField = `${lowercasePatientName}LastName`;
    const dateOfBirthField = `${lowercasePatientName}DateOfBirth`;

    const relationships = findRelationshipsFor(values);
    const isPhysician = Party.PHYSICIAN === party;
    const showPatientDemographicQuestions = isPhysician
        || (Object.keys(initialValues).includes(firstNameField) && relationship && relationship !== Relationship.EMPLOYEE);
    return (
        <QuestionPanel headerText={`Who is the ${lowercasePatientName}?`}
                       detailsText={PatientType.PATIENT === patientName && 'The patient is the person who is receiving care (from an employee or physician). For instance, if the claim is for the care of a child, choose "Family member" or "Covered dependent" for the relationship.'}
                       panelContent={
                           <div>
                               <SelectDropdown id="relationship" label="Relationship" required={true}
                                               options={relationships.map(r => ({
                                                   id: getKeyByValue(Relationship, r).replace(/_/g, '-'),
                                                   text: Party.EMPLOYEE === party && Relationship.EMPLOYEE === r ? Relationship.MYSELF : r,
                                                   value: r,
                                               }))}
                                               changeCallback={(target: HTMLSelectElement) => {
                                                   if(target.value === Relationship.EMPLOYEE) {
                                                       setFieldValue(firstNameField, values.firstName)
                                                       setFieldValue(lastNameField, values.lastName)
                                                       setFieldValue(dateOfBirthField, values.dateOfBirth)
                                                       return;
                                                   }
                                                   setFieldValue(firstNameField, '')
                                                   setFieldValue(lastNameField, '')
                                                   setFieldValue(dateOfBirthField, '')
                                                   if(isPhysician) {
                                                       setFieldValue('firstName', '')
                                                       setFieldValue('lastName', '')
                                                       setFieldValue('patientRelationship', '')
                                                       setFieldValue('patientRequiresCare', '')
                                                       setFieldValue('recommendedTimeOff', '')
                                                       setFieldValue('recommendedTimeOffDays', '')
                                                       setFieldValue('recommendedTimeOffHours', '')
                                                       setFieldValue('returnToWork', '')
                                                       setFieldValue('returnToWorkDays', '')
                                                       setFieldValue('returnToWorkHours', '')
                                                   }
                                               }}/>
                               {Relationship.COVERED_DEPENDENT === relationship && <RadioGroup id="dependent-relationship" label="Dependent relationship" required={true}
                                            radioProps={Object.keys(DependentRelationship).map(dependentRelationship => ({
                                                id: dependentRelationship.replace(/_/g, '-').toLowerCase(),
                                                text: (DependentRelationship as any)[dependentRelationship]
                                            }))}/>}
                               {showPatientDemographicQuestions && <Callout>
                                   <DependentChoice/>
                                   <TextInput id={`${lowercasePatientName}-first-name`} label={`${patientName}'s first name`} required={true} maxLength={1024}/>
                                   <TextInput id={`${lowercasePatientName}-last-name`} label={`${patientName}'s last name`} required={true} maxLength={1024}/>
                                   <DateInput id={`${lowercasePatientName}-date-of-birth`} label={`${patientName}'s date of birth`} required={true}/>
                               </Callout>}
                           </div>
                       }
        >
        </QuestionPanel>
    )
};
export default AboutRelationship;